let g;
const e = (o) => {
  g = o.logger;
};
export {
  e as initConfig,
  g as logger
};
